import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Selector de varias ciudades (casillas). Sin ninguna marcada significa «todas». `value` es una lista de nombres.
export default function CityMultiSelect({ id, label, options = [], value = [], onChange, emptyLabel = 'Todas las ciudades', compact = false }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  // Una ciudad guardada que ya no está en la lista del negocio se sigue mostrando (y se puede quitar).
  const all = [...options, ...value.filter((c) => !options.includes(c))];
  const toggle = (city) => onChange(value.includes(city) ? value.filter((c) => c !== city) : [...value, city]);
  const summary = value.length ? value.join(', ') : emptyLabel;

  return (
    <div ref={box} className="relative">
      <button
        type="button" id={id} aria-label={`${label}: ${summary}`} aria-haspopup="true" aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className={`w-full flex items-center justify-between gap-2 bg-seryi-bg-dark border border-seryi-bg-light text-seryi-heading focus:outline-none ${compact ? 'rounded-lg px-2 py-1 text-[11px]' : 'rounded-xl px-3 py-2 text-xs'}`}
      >
        <span className="truncate text-left">{summary}</span>
        <ChevronDown size={compact ? 12 : 14} className="shrink-0" />
      </button>
      {open && (
        <div role="group" aria-label={label} className="absolute z-20 mt-1 min-w-full max-h-64 overflow-auto bg-seryi-bg-dark border border-seryi-bg-light rounded-xl shadow-xl py-1">
          <label className="flex items-center gap-2 px-3 py-1.5 text-xs text-seryi-heading cursor-pointer hover:bg-seryi-bg-light/40">
            <input type="checkbox" checked={value.length === 0} onChange={() => onChange([])} />
            {emptyLabel}
          </label>
          {all.map((city) => (
            <label key={city} className="flex items-center gap-2 px-3 py-1.5 text-xs text-seryi-heading cursor-pointer hover:bg-seryi-bg-light/40">
              <input type="checkbox" checked={value.includes(city)} onChange={() => toggle(city)} />
              {city}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
